(function() {

  document.querySelectorAll('.dropdown-menu-item').forEach((item) => {
    const list = item.querySelector('.dropdown-menu-item-list');
    const trigger = item.querySelector('.menu-drawer__menu-item-button');
    if (!list || !trigger) return;

    trigger.addEventListener('click', () => {
      const isActive = list.classList.toggle('active-item');
      item.classList.toggle('active-item', isActive);
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

      if (isActive) {
        window.MegaMenuMotion?.staggerCards(list, 100);
      } else {
        window.MegaMenuMotion?.resetCards(list);
      }
    });
  });

  document.querySelectorAll('#menu-drawer a[href*="#"]').forEach((link) => {
    link.addEventListener('click', () => {
      const url = new URL(link.href, window.location.href);
      if (!url.hash || url.pathname !== window.location.pathname) return;
      document.querySelector('#menu-drawer .menu-drawer__close')?.click();
    });
  });

  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (drawerDetails) {
    drawerDetails.addEventListener('toggle', () => {
      if (!drawerDetails.open) return;
      document.querySelectorAll('.dropdown-menu-item-list.active-item').forEach((list) => {
        window.MegaMenuMotion?.staggerCards(list, 250);
      });
    });
  }
})();
